/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, KONOIKE){
	const a = 'is-active';
	const v = 'is-visible';
	const h = 'is-hidden';
	const f = 'is-fixed';
	const anime = 'is-animation';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';
	const arrowPrevThin = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left_thin" /></svg></button>';
	const arrowNextThin = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right_thin" /></svg></button>';
	const arrowPrevBold = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left_bold" /></svg></button>';
	const arrowNextBold = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right_bold" /></svg></button>';

	// ===========================================================================
	// メインビジュアル高さ調整
	const mainVisHeight = () => {
		const setHeight = () => {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		}
		setHeight();
		window.addEventListener('resize', setHeight);
	};

	// プロジェクトストーリースライド
	const projectStorySlider = () => {
		if($('.js-projectStory-slider').length) {
			$('.js-projectStory-slider').slick({
				infinite: true,
				speed: 1000,
				autoplay: false,
				pauseOnHover: false,
				autoplaySpeed: 5000,
				slidesToShow: 3,
				arrows: true,
				dots: false,
				prevArrow: arrowPrevThin,
				nextArrow: arrowNextThin,
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							slidesToShow: 2,
							prevArrow: arrowPrev,
							nextArrow: arrowNext,
						},
					}, {
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							prevArrow: arrowPrev,
							nextArrow: arrowNext,
						}
					}
				]
			});
		}
	};

	// TOPICSスライド
	const topicsSlider = () => {
		if($('.js-topics-slider').length) {
			$('.js-topics-slider').slick({
				infinite: true,
				speed: 1000,
				autoplay: false,
				pauseOnHover: false,
				autoplaySpeed: 5000,
				slidesToShow: 3,
				arrows: true,
				dots: true,
				prevArrow: arrowPrevBold,
				nextArrow: arrowNextBold,
				appendDots: $('.top-topics-slider-dots'),
				appendArrows: $('.top-topics-slider'),
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							slidesToShow: 2,
							arrows: false,
						},
					}, {
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							arrows: false,
						}
					}
				]
			});
		}
	};

	// KONOIKEジャーナルスライド
	const journalSlider = () => {
		if($('.js-journal-slider').length) {
			$('.js-journal-slider').slick({
				infinite: true,
				speed: 1000,
				autoplay: false,
				pauseOnHover: false,
				autoplaySpeed: 5000,
				slidesToShow: 1,
				arrows: true,
				dots: false,
				centerMode: true,
				centerPadding: '100px',
				// variableWidth: true,
				prevArrow: arrowPrevThin,
				nextArrow: arrowNextThin,
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							prevArrow: arrowPrev,
							nextArrow: arrowNext,
							centerPadding: '5vw',
						},
					}
				]
			});
			// 1枚だけの場合
			if($('.top-journal-slider-item').length === 1) {
				$('.js-journal-slider').addClass('is-one');
			}
		}
	};

	// 動画設定
	const mainMovie = () => {
		let tag = document.createElement('script');
		tag.src = "https://www.youtube.com/player_api";
		let firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	};

	// メインビジュアルアニメーション
	const mainVisAnimation = () => {
		// 動画設定
		let player;
		let thisId = $('#movie').attr('data-id');
		function onYouTubeIframeAPIReady() {
			player = new YT.Player('movie', {
				videoId: thisId,
				playerVars: {
					'loop': 1,
					'autoplay': 1,
					'controls': 0,
					'mute': 1,
					'rel': 0,
					'disablekb': 1,
					'playsinline': 1,
				},
				events: {
					'onStateChange': onPlayerStateChange
				}
			});
		}
		function onPlayerStateChange(e) {
			let status = e.target.getPlayerState();
			if (status == YT.PlayerState.ENDED) {
				player.playVideo();
				player.mute();
			}
		}

		// body縦スクロール非表示
		$('body').addClass(f);

		$('.js-animation-mainVis').one('inview', (event, isInView) => {
			// PCのみ動画
			if($(window).width() > 1024) {
				onYouTubeIframeAPIReady();
			}
			$('.top-mainVis-txt').addClass(anime).delay(2000).queue(function(next){
				$('.top-mainVis-txt').removeClass('is-black');
				$('.top-mainVis-img').addClass(anime);
				$('.header').addClass(anime);
				$('.top-important').addClass(anime);
				$('.top-mainVis-topics').addClass(anime);
				$('.top-mainVis-btns').addClass(anime);
				$('.top-mainVis-link').addClass(anime);
				$('.top-mainVis-arrow').addClass(anime);
				$('.top-mainVis-bnr').addClass(anime);
				$('body').removeClass(f);
				next();
			}).delay(2000).queue(function(next){
				$('.top-mainVis-txt').addClass(h);
				next();
			});
		});


		// TOPICK／ボタン
		let timer, flag;
		$(window).scroll((e) => {
			let thisScroll = $(e.currentTarget).scrollTop();

			if (timer) clearTimeout(timer);
			if (thisScroll === 0 && flag) {
				$('.js-mainVis-topics').removeClass(h);
				flag = false;
			} else if (thisScroll > 0 && !flag) {
				$('.js-mainVis-topics').addClass(h);
				flag = true;
			}
		});
	};

	// 各セクション　アニメーション
	const inviewAnimation = () => {
		// プロジェクトストーリー
		$('.js-projectStory-block').on('inview', (event, isInView) => {
			$('.js-projectStory-block .js-animation-h2').addClass(anime).delay(1500).queue(function(next){
				$('.js-projectStory-block .js-txtLink').addClass(anime);
				$('.js-projectStory-slider').addClass(anime);
				$('.js-projectStory-slider').slick('slickPlay');
				$('.js-projectStory-slider').slick('setPosition');
			});
		});
		// ソリューション
		$('.js-solution-block').on('inview', (event, isInView) => {
			$('.js-solution-block').addClass(anime).delay(1200).queue(function(next){
				$('.js-solution-block .js-animation-h2').addClass(anime);
			});
		});
		// トピックス
		$('.js-topics-block').on('inview', (event, isInView) => {
			$('.js-topics-block').addClass(anime).delay(400).queue(function(next){
				$('.js-topics-block .js-animation-h2').addClass(anime);
				$('.js-topics-slider').slick('slickPlay');
				$('.js-topics-slider').slick('setPosition');
			});
		});
		// ニュース
		$('.js-news-block').on('inview', (event, isInView) => {
			$('.js-news-block').addClass(anime);
			$('.js-news-block-01 .js-animation-h2').addClass(anime).delay(1000).queue(function(next){
				$('.js-news-block-02 .js-animation-h2').addClass(anime);
			});
		});
		// KONOIKEジャーナル
		$('.js-journal-block').on('inview', (event, isInView) => {
			$('.js-journal-block').addClass(anime).delay(600).queue(function(next){
				$('.js-journal-block .js-animation-h2').addClass(anime);
				$('.js-journal-block .js-txtLink').addClass(anime);
				$('.js-journal-slider').slick('slickPlay');
				$('.js-journal-slider').slick('setPosition');
			});
		});
		// サステナビリティ
		$('.js-sustainability-block').on('inview', (event, isInView) => {
			$('.js-sustainability-block').addClass(anime).delay(1400).queue(function(next){
				$('.js-sustainability-block .js-animation-h2').addClass(anime);
			});
		});
		// 企業情報
		$('.js-company-block').on('inview', (event, isInView) => {
			$('.js-company-block').addClass(anime).delay(600).queue(function(next){
				$('.js-company-block .js-animation-h2').addClass(anime);
			});
		});
		// IR情報
		$('.js-ir-block').on('inview', (event, isInView) => {
			$('.js-ir-block').addClass(anime).delay(600).queue(function(next){
				$('.js-ir-block .js-animation-h2').addClass(anime);
			});
		});
		// 採用情報
		$('.js-recruit-block').on('inview', (event, isInView) => {
			$('.js-recruit-block').addClass(anime).delay(400).queue(function(next){
				$('.js-recruit-block .js-animation-h2').addClass(anime);
			});
		});
	};

	// 重要なお知らせ
	const importantNewsText = () => {
		if($('.js-important-txt').length) {
			$('.js-important-txt').each((idx, ele) => {
				let $txt = $(ele).text();
				if($(window).width() < 768) {
					let slicetext = $txt.length > 26 ? ($txt).slice(0,26)+"…" : $txt;
					$(ele).text(slicetext);
				}
			});
		}
	};

	// ページスクロール
	const pageScroll = () => {
		$(window).scroll((e) => {
			let thisScroll = $(e.currentTarget).scrollTop();
			let winH = $(window).height();
			if(thisScroll > winH) {
				$('.top-mainVis-img').css('visibility', 'hidden');
			} else {
				$('.top-mainVis-img').css('visibility', 'visible');
			}
		});
	};

	// ==============================================================================
	mainMovie();
	mainVisHeight();
	projectStorySlider();
	topicsSlider();
	journalSlider();
	inviewAnimation();
	importantNewsText();
	pageScroll();
	window.onload = () => {
		mainVisAnimation();
	}

})(window.jQuery, window.KONOIKE);
